import { useFlags } from 'launchdarkly-react-client-sdk';
import { LDFeatureFlags } from '../enums';

export const useSquareNav = () => {
  const ldFlags = useFlags();
  return Boolean(ldFlags[LDFeatureFlags.FRANCHISE_NEW_NAVIGATION]);
};
